<atlas-modal>
  <atlas-modal-header>
    {{ 'USER_REQUIRED_MODAL.TITLE' | translate }}
  </atlas-modal-header>
  <atlas-modal-content>
    <p style="margin: 0; padding: 24px">{{ 'USER_REQUIRED_MODAL.DESCRIPTION' | translate }}</p>
  </atlas-modal-content>
</atlas-modal>
